import React, { useEffect, useRef, useState } from "react";
import api from "../../services/api";
import {Header, SiteLogo} from '../../components';
import '../../App.css';
import './session.css'
import { faEyeSlash,faEye,faLock,faEnvelope,faUser} from "@fortawesome/free-solid-svg-icons";
import { useLocation, Navigate } from 'react-router-dom';
import {Helpers} from '../../helpers'
function Session({Contexto}) {
    let location = useLocation();
    const [mode, setMode] = useState('login');
    const [user, setUser] = useState([]);
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [token,setToken] = useState(0)
    const [tokenLocal,setTokenLocal] = useState()
    const [viewPass, setViewPass] = useState('password')
    const [iconEye, setIconEye] = useState(true)
    const [resend,setResend] = useState(false)
    const [time,setTime] = useState(0)
    const input_user = useRef()
    const input_email = useRef()
    const input_pass = useRef()
    const input_token = useRef()
    const [Popup,setPopup] = useState({status:false,message:""})


    useEffect( () => {
        //verificar si hay algun login
        verifySession();
    }, []);
    const verifySession = async() =>{
        const currentSession = await localStorage.getItem('userSession')
        if(currentSession != '' &&  currentSession != undefined &&  currentSession != null){
            ShowPop("You already have an active session: " + currentSession)
            window.location.href = '/home';
        }
    }
    const ShowPop = (text) =>{        
        setPopup({status:true,message:text})        
      }
      const PopUp = ( ) => {        
          return (<>
          <div className="pop-add" >
              <div className="pop-add-content message-pop">
                  <h2>{Popup?.message}</h2>      
                  <div className="pop-exit-div">
                      <button  onClick={()=>setPopup({status:false,message:""})} 
                      className="pop-exit">ACCEPT</button>
                  </div>
              </div>
          </div>
          </>)
      }
    const Login = async ()=>{
        if(username == '' || pass == ''){ShowPop('User or pass is empty.');return}
        let url = `/test/?function=GetUser&username=${username}&pass=${pass}` 
        await api
        .get(url)
        .then((response) =>{ 
            let userDB = response.data.content;
            if(userDB.length > 0){
                if(userDB[0].password == pass){
                    setUser(userDB[0]);
                    setPass('')
                    //console.log(location)
                    //console.log(user)
                    localStorage.setItem('userSession',userDB[0].username)
                    window.location.href = '/home';
                } else {
                    //console.log(userDB[0].password)
                }
            } else {
                ShowPop('Invalid user or pass.')
            }
        })
        .catch((err) => {
            console.error("ops! ocorreu um erro" + err);
        });
    }
    const Register = async()=>{
        ShowPop('Try register')
        let url = `/test/?function=verifyUser&username=${username}&email=${email}` 
        if(username == '' || pass == '' || email == ''){
            ShowPop('User or pass is empty.')
            return;
        }
        await api
            .get(url)
            .then((response) =>{ 
                //console.log(response)
                let userDB = response.data.content;
                if(userDB > 0){
                    ShowPop('User already exist.')
                    changeMode(1)
                    return;
                } else if (email.includes('@') && email.includes('.') &&  userDB.length <= 0 ){
                    let url2 = `/test/?function=CreateUser&username=${username}&pass=${pass}&email=${email}` 
                    api
                        .get(url2)
                        .then((response) =>{ 
                            ShowPop('User created.')
                            setUsername('')
                            setPass('')
                            changeMode(0)
                        })
                        .catch((err) => {
                            changeMode(1)
                            console.error("ops! ocorreu um erro" + err);
                        });
                } else {
                    changeMode(1)
                    ShowPop('Invalid Email.')
                }
            })
            .catch((err) => {
                console.error("ops! ocorreu um erro" + err);
                return;
            });
    }
    const handlerUser=()=>{
        setUsername(input_user.current.value)
    }
    const handlerPass=()=>{
        setPass(input_pass.current.value)
    }
    const handlerEye =()=>{
        setIconEye(!iconEye);
        setViewPass(iconEye?'text':'password');
    }
    const handlerEmail=()=>{
        setEmail(input_email.current.value)
    }
    const handlerToken=()=>{
        //email verification
        setToken(input_token.current.value)
    }
    const startTime = () =>{
     
        //setTime(seconds)
       // console.log('time ->' +time)
        if(time > 0){
            let _time = time - 1
            //console.log('time 2 ->' +_time)
            setTime(_time)
        }else{
            setResend(false)
            //console.log('segundo')
        }

        
    }
    const sendTokenToEmail = async(_token) =>{
       if(_token > 0){
        //console.log('email enviado')
        await fetch(`https://justhodl.io/api/email/verification/?name=${username}&email=${email}&code=${_token}` )
       }else {
        console.log('email no enviado')
       }
       
    }
    const handlerSend = async() => {
        //send token from email
        //antispan
        if(time==0){
            setTime(60)
            const _token = Math.floor((Math.random() * 1000000) + 100000);
            changeMode(2) 
            setTokenLocal(_token)
            setResend(true)
            ShowPop(_token)
            //aqui se envia el token al email
            sendTokenToEmail(_token)
        }
        
    }
    const ValidateToken = async() => {
        //send token from email
        //antispan
        if(token==tokenLocal){
            //se puede enviar el mail
            
            Register()
            
        } else {
            ShowPop('Invalid verification code try again.')
        }
        
    }
    const changeMode = (_mode) =>{
        switch (_mode) {
            case 0:setMode('login'); break;
            case 1:setMode('register'); break;
            case 2:setMode('token'); break;
            default:setMode('login'); break;
        }
    }
    const handlerSession = () =>{
        switch (mode) {
            case 'token':ValidateToken(); break;
            case 'login':Login();  break;
            case 'register':handlerSend(); break;
            default:Login(); break;
        }
    }
    useEffect(()=>{
       
        let contador = setTimeout(()=>{
            startTime()
        },1000)
        if(time<1){
            setTime(0)
            setResend(false)
            clearTimeout(contador)
        }
        //return clearTimeout(contador)
    },[time])

    return (<>
        
        {Popup?.status && <PopUp />}
        {mode =='login' && <Header loginMode/>}
        {mode !='login' && <Header registerMode/>}
        <div className="page-session">
            <div className="form-session">
                <div className="form-session-left">
                    {mode=='token'?<h3>Email Verification!</h3>:<h3>Hello!</h3>}
                    {mode=='token'
                    &&
                    <p className='session-token-text'>We have sent a verification 
                        code to your email, please enter
                        it to verify and create your account.
                    </p> }
                    <div className="form-session-inputs">
                        {mode!='token' 
                        &&
                        <div className="session-input">
                            {new Helpers().Icon(faUser,'session-icon-left')}
                            <input 
                                ref={input_user}
                                className='session-user-input'
                                type={'text'}
                                onChange={handlerUser}
                                placeholder={mode=='login'?'Username or Email':'Username'}
                                value={username}
                            />
                            {new Helpers().Icon(faEye,'session-icon-right hidden')}
                        </div>}
                        {mode!='token'
                        &&
                        mode!='login'
                        &&
                        <div className="session-input">
                            {new Helpers().Icon(faEnvelope,'session-icon-left')}
                            <input 
                                ref={input_email}
                                className='session-email-input'
                                type={'email'}
                                onChange={handlerEmail}
                                placeholder={'Email'}
                                value={email}
                            />
                            {new Helpers().Icon(faEye,'session-icon-right hidden')}
                        </div>}
                        {mode!='token'
                        &&
                        <div className="session-input">
                            {new Helpers().Icon(faLock,'session-icon-left')}
                            <input 
                                ref={input_pass}
                                className='session-pass-input'
                                type={viewPass}
                                onChange={handlerPass}
                                placeholder={'Password'}
                                value={pass}
                            />
                            <div
                                onClick={handlerEye}  
                            >
                                {new Helpers().Icon(faEye,iconEye?'session-icon-right ':'session-icon-right hidden')}
                                {new Helpers().Icon(faEyeSlash,iconEye?'session-icon-right hidden':'session-icon-right')}
                            </div>
                        </div>}
                        {mode=='token'
                        &&
                        <div className="session-input">
                            {new Helpers().Icon(faLock,'session-icon-left')}
                            <input 
                                ref={input_token}
                                className='session-token-input'
                                type={'number'}
                                onChange={handlerToken}
                                placeholder={'Validation code'}
                                value={token}
                                maxLength={5}
                            />
                            <span 
                                className='session-send-right'
                                onClick={handlerSend}
                            >
                                {resend?'resend('+time+'s)':'send code'}
                            </span>
                        </div>}
                    </div>
                    {mode=='login'
                    &&
                    <div className="session-form-remember">
                        <div className="check-remember">
                            <input type="checkbox" ></input>
                            <span>Remember me</span>
                        </div>
                        <span>Forgot password?</span>
                    </div>}
                    <button 
                        className="btn-session-login"
                        onClick={handlerSession}
                    >
                        {mode=='login' && 'Log in'}
                        {mode=='register' && 'Register'}
                        {mode=='token' && 'Validate email'}
                        
                    </button>
                    <span className="form-or hide">OR</span>
                    <button className="btn-google hide">Continue with Google</button>
                    <button className="btn-apple hide">Continue with Apple</button>
                </div>
                <div className="form-session-right">
                    <img src={'./assets/principal/justhodl_icon_logo.png'}  height={150}/>
                    <img src={'./assets/principal/justhodl_icon_text.png'} height={50}/>
                </div>
            </div>
            
        </div>
       
    </>);
  }
  
  export default Session;

  /* <div className={'testeo'}> 
            <p>username:{username}</p>
            <p>pass:{pass}</p>
            <p>email:{email}</p>
            <p>token:{token}</p>
        </div>
        <div className={'testeo'}> 
            <button onClick={()=>{changeMode(0)}}>login</button>
            <button onClick={()=>{changeMode(1)}}>register</button>
            <button onClick={()=>{changeMode(2)}}>token</button>
            <h3>Mode:{mode}</h3>
        </div> */